// src/routes/WealthMethodRoutes.tsx
import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import WealthMethod from "../components/Funnels/WealthMethod";
import AuthorityQuotientTest from "../components/Funnels/AuthorityQuotientTest";
import AuthorityQuotientResult from "../components/Funnels/AuthorityQuotientTest/AuthorityQuotientResult";
import WealthMethodOutline from "../components/Funnels/WealthMethod/WealthMethodOutline";
import WealthMethodQuizFunnel from "../components/Funnels/WealthMethod/WealthMethodQuizFunnel";
import WealthMethodQuiz from "../components/Funnels/WealthMethod/WealthMethodQuiz";
import WealthMethodFullReport from "../components/Funnels/WealthMethod/WealthMethodFullReport";

import WealthMethodCheckout from "../components/Funnels/WealthMethod/WealthMethodCheckout";
import WealthMethodOptinSuccess from "../components/Funnels/WealthMethod/WealthMethodOptinSuccess";
import WealthMethodLeadMagnetOptin from "../components/Funnels/WealthMethod/WealthMethodLeadMagnetOptin";

import WealthMethod2 from "../components/Funnels/WealthMethod/WealthMethod2";
import WealthMethodLayout from "../layouts/WealthMethodLayout";
import WealthMethodDBCUpsell from "../components/Funnels/WealthMethod/WealthMethodDBCUpsell";
import { OptInPage } from "../pages/wealthmethod/OptinPage";
import WealthMethodSalesPage from "../pages/wealthmethod/WealthMethodSalesPage";

// Simple loading fallback used during lazy load
const LoadingFallback: React.FC = () => (
  <div className="min-h-[40vh] flex items-center justify-center">
    <div className="animate-spin h-8 w-8 border-4 border-t-[#E50000] border-[#E9EDF3] rounded-full" />
  </div>
);

/**
 * NOTE:
 * - These routes are intended to be mounted at `/wealth-method/*` from the parent router.
 * - All paths below are relative. Do NOT prefix them with a leading slash.
 */
export const WealthMethodRoutes: React.FC = () => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        {/* When mounted at /wealth-method:
            path=""              -> /wealth-method
            path="sl"            -> /wealth-method/sl
            path="checkout"      -> /wealth-method/checkout
            etc.
        */}
        <Route
          path="sl"
          element={
            <WealthMethodLayout>
              <WealthMethod />
            </WealthMethodLayout>
          }
        />
        <Route
          index
          element={
            <WealthMethodLayout>
              <WealthMethod2 />
            </WealthMethodLayout>
          }
        />

        <Route
          path="authority-test"
          element={
            <WealthMethodLayout>
              <AuthorityQuotientTest />
            </WealthMethodLayout>
          }
        />
        <Route
          path="authority-result"
          element={
            <WealthMethodLayout>
              <AuthorityQuotientResult />
            </WealthMethodLayout>
          }
        />
        <Route
          path="outline"
          element={
            <WealthMethodLayout>
              <WealthMethodOutline />
            </WealthMethodLayout>
          }
        />
        <Route
          path="quiz"
          element={
            <WealthMethodLayout>
              <WealthMethodQuizFunnel />
            </WealthMethodLayout>
          }
        />
        <Route
          path="book-quiz"
          element={
            <WealthMethodLayout>
              <WealthMethodQuiz />
            </WealthMethodLayout>
          }
        />
        <Route
          path="book-quiz/result"
          element={
            <WealthMethodLayout>
              <WealthMethodFullReport />
            </WealthMethodLayout>
          }
        />
        <Route
          path="leads"
          element={
            <WealthMethodLayout>
              <WealthMethodLeadMagnetOptin />
            </WealthMethodLayout>
          }
        />
        <Route
          path="leads/success"
          element={
            <WealthMethodLayout>
              <WealthMethodOptinSuccess />
            </WealthMethodLayout>
          }
        />

        <Route path="checkout" element={<WealthMethodCheckout />} />
        <Route path="dbc-upsell" element={<WealthMethodDBCUpsell />} />
        <Route path="opt-in" element={<OptInPage />} />
        <Route path="buy-now" element={<WealthMethodSalesPage />} />
      </Routes>
    </Suspense>
  );
};

export default WealthMethodRoutes;
